import script from "./no-search-data.vue?vue&type=script&setup=true&lang=ts"
export * from "./no-search-data.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__